<script lang="ts">
	import { _ } from 'svelte-i18n';

	export let showPromptError = false;
</script>

<div class="label-section">
	{#if showPromptError}
		<p class="prompt-error-text">
			{$_('hubs.copywriter.errors.invalid_prompt')}
		</p>
	{:else}
		<p class="disclaimer-text">
			{$_('hubs.copywriter.disclaimer.text')}
			<a
				href="https://alidasupport.zendesk.com/hc/en-us/articles/39588098938644"
				target="_blank"
				rel="noopener noreferrer"
				class="learn-more-link">{$_('common.learn.more')}.</a>
		</p>
	{/if}
</div>

<style>
	.prompt-error-text {
		margin: 0;
		color: #e52b20;
		font-size: 12px;
		line-height: 1.4;
	}

	.disclaimer-text {
		margin: 0;
		color: #6b7280;
		font-size: 12px;
		line-height: 1.4;
	}

	.learn-more-link {
		color: #09c1d9;
		text-decoration: none;
	}

	.learn-more-link:hover {
		text-decoration: underline;
	}
</style>
